import Icon from '../../../common/Icon/Icon';
import { MarkupText } from 'preact-i18n';
import { LocationSelector } from '../../LocationSelector/LocationSelector';
import { LocationType } from '../../../common';
import { WidgetTestVariant } from '../../../config';
import PaxAmountSelector from '../../PaxAmountSelector/PaxAmountSelector';
import TravelClassSelector from '../../TravelClassSelector/TravelClassSelector';
import DurationSelector from '../../DurationSelector/DurationSelector';
import { DateSelector, TravelDateType } from '../../DateSelector/DateSelector';
import DateSelectorSeparator from '../../DateSelectorSeparator/DateSelectorSeparator';
import ContinueButton from '../../ContinueButton/ContinueButton';
import { Fragment, FunctionalComponent, h } from 'preact';
import { BookingState, connectStore } from '../../../store';

export interface AMContentProps {
  showDurationSelector: boolean;
  setFocusElement: (HTMLElement) => void;
  testVariant: WidgetTestVariant;
}
interface StoreProps {
  enableCompactWidget: boolean;
}

const mapStateToProps = ({ enableCompactWidget }: BookingState): StoreProps => ({
  enableCompactWidget,
});

type EffectiveProps = AMContentProps & StoreProps;

export const AMContent: FunctionalComponent<AMContentProps> = connectStore({
  mapStateToProps,
})(({ showDurationSelector, setFocusElement, testVariant, enableCompactWidget }: EffectiveProps) => {
  return (
    <Fragment>
      <div class="amBanner flex flex--middle flex--nowrap ps-xsmall-y font-body-1" data-test-am-banner>
        <Icon iconName="am-logo" class="is-xsmall" />
        <span class="ps-small-l">
          <MarkupText id="aurinkomatkat.inCooperation" />
        </span>
      </div>
      <div class="locations white-bg border rounded">
        <LocationSelector locationType={LocationType.ORIGIN} isAward={false} testVariant={testVariant} />
        <LocationSelector locationType={LocationType.DESTINATION} isAward={false} testVariant={testVariant} />
      </div>

      <PaxAmountSelector class="bw-pax-amount passengers contentItem white-bg border rounded" />
      {!enableCompactWidget && (
        <TravelClassSelector class="bw-travel-class travelClass contentItem white-bg border rounded" />
      )}
      <div className={`travelDates white-bg border rounded ${showDurationSelector ? 'withDuration' : ''}`}>
        {showDurationSelector && (
          <DurationSelector class="bw-duration duration contentItem" data-test-duration-selector />
        )}

        <DateSelector class="bw-departure departure contentItem" type={TravelDateType.DEPARTURE} />

        {!showDurationSelector && (
          <DateSelector
            class="bw-return return contentItem"
            type={TravelDateType.RETURN}
            data-test-return-date-selector
          />
        )}

        <DateSelectorSeparator
          class="contentSeparator white-bg nordic-blue-900-text mr-xxsmall-r"
          data-test-date-separator
        />
      </div>
      <div className={'bw-cta callToAction'}>
        <ContinueButton
          class="submit ctaButton"
          ref={(elem: ContinueButton) => elem && setFocusElement(elem?.base as HTMLElement)}
        />
      </div>
    </Fragment>
  );
});
